import { MODEL_TEMPLATE as audience } from "@/store/modules/audiences/defaults"

const MODEL_TEMPLATE = {
  _changed: false,
  id: null,
  adAccountId: null,
  isPublished: false,
  name: null,
  adId: null, // Facebook ad ID if published
  status: "DRAFT", // ad status if published or 'DRAFT'
  ...audience,
  media: null,

  propagationContent: "web",

  campaign: {
    campaignId: null,
    adAccountId: null,
    name: null,
    specialAdCategories: ["NONE"],
    objective: null, // campaign objective, CONVERSIONS = konverze, LINK_CLICKS = návštěvnost
    status: "PAUSED",
  },

  // adCreative
  creative: {
    // this is for dynamic creative, not used yet
    // assetFeedSpec: {
    //   adFormats: ['SINGLE_IMAGE'],
    //   bodies: [null], // primary texts
    //   descriptions: [null],
    //   titles: [null],
    // },
    objectStorySpec: {
      pageId: null,
      link: null,
      caption: null,
      message: null, // primary text in manager
      name: null, // headline in manager
      description: null, // description in manager
    },
    callToActionType: null,
  },

  // adset
  adset: {
    adsetId: null,
    status: "PAUSED",
    bidStrategy: "LOWEST_COST_WITHOUT_CAP",
    billingEvent: "IMPRESSIONS",
    startTime: null,
    endTime: null,
    endTimeEnabled: false,
    budgetType: "daily",
    dailyBudget: 20000,
    lifetimeBudget: 20000,
    promotedObject: {
      pixelId: null,
      customEventType: null,
    },
  },
}

export { MODEL_TEMPLATE }
